<template>
  <div>
    <el-form-item
      class="custom-label__input width25"
      label="Công văn liên quan"
      prop="relationDocs"
      ref="relationDocsRef"
      :rules="relationDocsRule"
    >
      <div class="flex-row flex__left">
        <el-upload
          :action="uploadAttachmentURL"
          :on-success="onUploadSuccess"
          :data="uploadRelationDocAdditionalData"
          :show-file-list="false"
          :headers="uploadAttachmentHeaders"
          :before-upload="
            file => validateUploadFile(file, validateUploadFileOptions)
          "
          :on-error="onUploadError"
          :on-change="() => (isUploadingRelationDocFlag = true)"
          v-loading="isUploadingRelationDocFlag && isUploading"
        >
          <el-button class="btnPlain margin-right-10">
            <i class="fas fa-cloud-upload-alt"></i>
            &nbsp;Tải file lên
          </el-button>
        </el-upload>
        <el-button class="btnPlain" @click="isOpenAddDocDialog = true">
          <i class="fas fa-mouse-pointer"></i>
          &nbsp;Chọn văn bản
        </el-button>
      </div>
    </el-form-item>
    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="relationDocs"
        v-if="relationDocs && relationDocs.length"
      >
        <el-table-column width="30">
          <template slot-scope="scope">
            <i
              class="download-icon fas fa-cloud-download-alt clickable"
              @click="downloadFile(scope.row)"
            ></i>
          </template>
        </el-table-column>

        <el-table-column label="Trích yếu" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="flex-row flex__left margin-right-10">
              <span class="file-text-input style-fullWidth">
                <el-input
                  class="style-fullWidth input-none__border input-inner-table inputBg__white"
                  placeholder="Trích yếu"
                  size="medium"
                  v-model="scope.row.quote"
                  :readonly="isDocRelation(scope.row)"
                ></el-input>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Số ký hiệu" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input
              size="medium"
              v-model="scope.row.docCode"
              placeholder="Số ký hiệu"
              class="style-fullWidth input-none__border input-inner-table inputBg__white"
              :readonly="isDocRelation(scope.row)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="Ngày văn bản" width="125" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-date-picker
              class="style-fullWidth input-none__border input-inner-table inputBg__white"
              v-model="scope.row.docDate"
              type="date"
              size="medium"
              :prefix-icon="' '"
              placeholder="dd/mm/yyyy"
              format="dd/MM/yyyy"
              :readonly="isDocRelation(scope.row)"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" header-align="left" width="40">
          <template slot-scope="scope">
            <i
              class="el-icon-circle-close font-size__large color__red clickable"
              @click="removeRelationDoc(scope.row)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <hc-commands-add-docs-dialog
      :isOpen="isOpenAddDocDialog"
      :deptId="deptId"
      v-if="isEnableAddDocDialog"
      @closeDialog="isOpenAddDocDialog = false"
      @dialogClosed="isEnableAddDocDialog = false"
      @changed="addDocRelations"
    />
  </div>
</template>

<script>
import FileTypeImage from "../../job/FileTypeImage";
import constants from "../../../constants";
import h from "../../../services/h";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import uploadFileMixin from "../../doc-in/uploadFileMixin";
import DialogAddDocs from "../../job/create-job/dialog-add-docs";
import HcCommandsAddDocsDialog from "./hc-commands-add-docs-dialog";
import hcDocRelationService from "../../../services/hcDocRelationService";
import dateUtils from "../../../dateUtils";
import downloadService from "../../../services/downloadService";

export default {
  name: "hc-commands-doc-relations",
  mixins: [handleRequestErrorMixin, uploadFileMixin],
  components: { HcCommandsAddDocsDialog, DialogAddDocs, FileTypeImage },
  props: ["objectId", "objectType", "deptId"],

  data() {
    return {
      relationDocs: [],
      oringalRelationDocs: [], //phục cho yêu cầu của test check thay đổi để disable nút cập nhật :(
      isUploadingRelationDocFlag: false,
      uploadRelationDocAdditionalData: {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.RELATION_DOC
      },
      isOpenAddDocDialog: false,
      isEnableAddDocDialog: false,
      validateUploadFileOptions: {
        acceptFileTypes: constants.DEFAULT_ACCEPTED_CONTENT_TYPE_ALL
      },
      relationDocsRule: null
    };
  },

  watch: {
    isOpenAddDocDialog(newValue) {
      newValue && (this.isEnableAddDocDialog = newValue);
    },
    objectId() {
      this.reloadData();
    }
  },

  created() {
    this.reloadData();
  },

  methods: {
    downloadFile(relationDoc) {
      return downloadService.downloadFileForHcCommandsDocRelation(
        this.objectId,
        this.objectType,
        relationDoc.referenceObjectType,
        relationDoc.referenceObjectId
      );
    },

    isDataChanged() {
      let arr1 = this.oringalRelationDocs;
      let arr2 = this.relationDocs;
      !arr1 && (arr1 = []);
      !arr2 && (arr2 = []);
      return (
        arr1.length !== arr2.length ||
        h.exists(
          arr1,
          item1 => !h.exists(arr2, item2 => this.isEqual(item1, item2))
        )
      );
    },

    isEqual(item1, item2) {
      return !(
        item1.referenceObjectType !== item2.referenceObjectType ||
        item1.referenceObjectId !== item2.referenceObjectId ||
        item1.docCode !== item2.docCode ||
        dateUtils.isDiff(item1.docDate, item2.docDate) ||
        item1.quote !== item2.quote
      );
    },

    reloadData() {
      this.loadRelationDocs().then(hcDocRelations => {
        this.bindToForms(hcDocRelations, (this.relationDocs = []));
        this.bindToForms(hcDocRelations, (this.oringalRelationDocs = []));
      });
    },

    getSubmitForms() {
      return h.collect(this.relationDocs, relationDoc => {
        return {
          referenceObjectType: relationDoc.referenceObjectType,
          referenceObjectId: relationDoc.referenceObjectId,
          docCode: relationDoc.docCode,
          docDate: relationDoc.docDate ? relationDoc.docDate.getTime() : null,
          quote: relationDoc.quote
        };
      });
    },

    bindToForms(hcDocRelations, relationDocs) {
      h.each(hcDocRelations, hcDocRelation => {
        relationDocs.push({
          referenceObjectType: hcDocRelation.referenceObjectType,
          referenceObjectId: hcDocRelation.referenceObjectId,
          docCode: hcDocRelation.docCode,
          docDate: hcDocRelation.docDate
            ? new Date(hcDocRelation.docDate)
            : null,
          quote: hcDocRelation.quote
        });
      });
    },

    loadRelationDocs() {
      if (!this.objectId) return Promise.resolve(null);

      switch (this.objectType) {
        case constants.HC_DOC_RELATION.OBJECT_TYPE.HC_CASE_COMMANDS:
          return hcDocRelationService
            .findAllForHcCaseCommands(this.objectId)
            .then(response => response.data);

        case constants.HC_DOC_RELATION.OBJECT_TYPE.HC_CASE_COMMANDS_COMMON:
          return hcDocRelationService
            .findAllForHcCaseCommandsCommon(this.objectId)
            .then(response => response.data);

        default:
          return Promise.resolve(null);
      }
    },

    isDocRelation(docRelation) {
      return (
        docRelation.referenceObjectType ===
        constants.HC_DOC_RELATION.REFERENCE_OBJECT_TYPE.VB_OUTGOING_DOC
      );
    },

    removeRelationDoc(relationDoc) {
      this.relationDocs.splice(this.relationDocs.indexOf(relationDoc), 1);
    },

    onUploadSuccess(vbAttachment) {
      this.isUploading = false;
      this.relationDocs.push({
        referenceObjectType:
          constants.HC_DOC_RELATION.REFERENCE_OBJECT_TYPE.VB_ATTACHMENT,
        referenceObjectId: vbAttachment.id,
        docCode: null,
        docDate: null,
        quote: vbAttachment.fileName
      });
    },

    isAdded(referenceObjectType, referenceObjectId) {
      return h.exists(
        this.relationDocs,
        relationDoc =>
          relationDoc.referenceObjectType === referenceObjectType &&
          relationDoc.referenceObjectId === referenceObjectId
      );
    },

    addDocRelations({ selectedDocs, objectType }) {
      this.isOpenAddDocDialog = false;
      let relationDoc_;
      h.each(selectedDocs, doc => {
        if (!this.isAdded(objectType, doc.id)) {
          let relationDoc = {
            referenceObjectType: objectType,
            referenceObjectId: doc.id,
            docCode: doc.docCode,
            docDate: doc.docDate ? new Date(doc.docDate) : null,
            quote: doc.quote
          };
          this.relationDocs.push((relationDoc_ = relationDoc));
        }
      });
      if (relationDoc_) this.$emit("docSelected", { relatedDoc: relationDoc_ });
    },

    changeValidate(isRequired) {
      if(isRequired) {
        this.relationDocsRule = {required: true, message: 'Trường dữ liệu bắt buộc'};
      } else {
        this.$refs.relationDocsRef.clearValidate();
        this.relationDocsRule = {};
      }
    },

    hasRelationDocs() {
      let result = !!this.relationDocs.length;
      console.log('result', result)
      return result
    }
  }
};
</script>

<style scoped>
.download-icon:hover {
  color: var(--color-blue) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-commands-doc-relations.vue